<template>
  <div
    class="row-container"
    :class="moduleInfo.Module.CssClass"
  >
    <template
      v-for="child in childData"
      :key="child.EntityID"
    >
      <LayoutsCol
        :module-info="child"
      />
    </template>
    <slot />
  </div>
</template>

<script>
import LayoutsCol from "@/components/content/LayoutsModule/LayoutsCol";
import {layoutRowMixin} from "@/mixins";

export default {
  name: "LayoutsRow",
  components: {
    LayoutsCol
  },
  mixins: [layoutRowMixin],
  props: {
    moduleInfo: {
      type: Object,
      required: true
    },
  },
};
</script>

<style lang="scss">
.row-container{
    @apply max-w-screen-xl mx-auto;
    @screen lg{
     @apply flex max-w-screen-xl;
    }
    //ako korisnik doda više od 2 kolone u editu, neće se prikazati
    .col-container{
      @apply hidden;
    }
    .col-container:first-child{
       @apply block;
        @screen lg{
            flex-basis: 75%;

           }
    }
    .col-container:nth-child(2){
       display: block;
        @screen lg{
            flex-basis: 25%;
            min-width: 360px;
            max-width: 360px;
           }
    }

}
</style>
